// extracted by mini-css-extract-plugin
export default {"collectionTitle":"CollectionTitle_collectionTitle__sy0rf"};